"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.everyKey = void 0;
function everyKey(subject, predicate, thisArg) {
    return Object.keys(subject).every(predicate, thisArg);
}
exports.everyKey = everyKey;
//# sourceMappingURL=everyKey.js.map